import React from 'react';
import {isEmpty} from "@helpers/helpers";

export const DeedState = {
    show: false,
    options: [
        {value: 'owner', label: 'ملکی', checked: false},
        {value: 'astan', label: 'آستان قدس', checked: false},
        {value: 'proxy', label: 'وکالتی', checked: false},
        {value: 'pending', label: 'قولنامه‌ای', checked: false},
        {value: 'endowment', label: 'اوقاف', checked: false},
        {value: 'store', label: 'سرقفلی', checked: false},
        {value: 'joint', label: 'مشاع', checked: false},
    ],
    selected_items: [],
};

const $deeds = {
    'owner': 'ملکی',
    'astan': 'آستان قدس',
    'proxy': 'وکالتی',
    'pending': 'قولنامه‌ای',
    'endowment': 'اوقاف',
    'joint': 'مشاع',
    'store': 'سرقفلی',
};

export const getDeeds = (key = null) => {
    let deeds = null;
    if (isEmpty(key)) {
        deeds = $deeds;
    } else if (!isEmpty(key) && typeof key === "string") {
        deeds = $deeds[key];
    } else if (typeof key === "object" && key.length) {
        deeds = [];
        for (let item of key) {
            deeds.push($deeds[item]);
        }
    }

    return deeds;
};


